import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { HORIZONTAL_CHIP_ORDER } from "../Search/FilterBar/filterIds";
import { useFilterControllerContext } from "../Search/FilterBar/FilterControllerContext";
import FilterChip from "../Search/FilterBar/FilterChip";

/**
 * Secondary "Filters" control for Enrich Workspace V4.
 * Uses the same FilterChip UI as Search; toggles the full toolbar.
 */
export default function CollapsedFiltersButton({
  expanded = false,
  onToggle,
  disabled = false,
}) {
  const controller = useFilterControllerContext();
  const summaries = controller?.summaries;

  const appliedCount = useMemo(() => {
    if (!summaries) return 0;
    return HORIZONTAL_CHIP_ORDER.reduce(
      (total, id) => total + (summaries[id]?.isActive ? 1 : 0),
      0
    );
  }, [summaries]);

  const hasValue = appliedCount > 0;

  return (
    <Box
      data-testid="collapsed-filters-button"
      sx={{ display: "inline-flex", flex: "0 0 auto" }}
    >
      <FilterChip
        label="Filters"
        active={expanded}
        hasValue={hasValue}
        count={appliedCount}
        badgeLabel={hasValue ? `${appliedCount} active` : undefined}
        variant="multi"
        valueFill={false}
        hideChevron
        disabled={disabled}
        onClick={onToggle}
        aria-controls="saved-search-filters-toolbar"
        aria-label={
          hasValue
            ? `${appliedCount} filters active. ${expanded ? "Hide" : "Show"} filter toolbar`
            : `${expanded ? "Hide" : "Show"} filter toolbar`
        }
      />
    </Box>
  );
}
